import Button from "@components/Button";
import { Input } from "@components/Input";
import Icon from "@components/Icon";
import { LOGIN, SIGNUP, VERIFY_OTP } from "@constants/internal-route.constant";
import { AuthHead, AuthLinks } from "@layout/AuthHead";
import { AuthService } from "@services/api/Auth.service";
import { ToastService } from "@services/utils/toast.service";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

export default function ForgetPassword() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const onSubmit = (formData) => {
    setIsLoading(true);
    AuthService.forgetPassword(formData)
      .then((res) => {
        navigate(VERIFY_OTP, {
          state: { token: res.body?.tempToken },
        });
      })
      .catch((err) => ToastService.error(err?.msg))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <AuthHead title="Forgot password?">
        Enter the email or username on your account and we’ll send a code to reset your password.
      </AuthHead>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          label="Email or username"
          registerProperty={{
            ...register("username", { required: "Please Enter username" }),
          }}
          isError={!!errors?.username}
          errorMessage={errors?.username?.message as string}
        />
        <div>
          <Button
            className="w-100 mt-2"
            color="primary"
            type="submit"
            size="lg"
            isLoading={isLoading}
            loadingText="Sending code..."
          >
            Send reset code
          </Button>
        </div>
        <AuthLinks>
          <Link to={LOGIN}>
            <Icon icon="arrow-left" size={14} /> Back to sign in
          </Link>
          <span>
            New here? <Link to={SIGNUP}>Start a free trial</Link>
          </span>
        </AuthLinks>
      </form>
    </>
  );
}
